import React from "react";
import styles from "./team-renderer-styles.module.css";

interface StaticTeamRendererProps {
  teamName: string;
  teamPath: string;
}

const StaticTeamRenderer: React.FC<StaticTeamRendererProps> = ({
  teamName,
  teamPath,
}): JSX.Element => {
  return (
    <div>
      <div className={styles["team-text"]}> {teamName} </div>
      <div className={styles["team-subtext"]}> {teamPath} </div>
    </div>
  );
};

export default StaticTeamRenderer;
